import script from "./tutorHistory.vue?vue&type=script&setup=true&lang=js"
export * from "./tutorHistory.vue?vue&type=script&setup=true&lang=js"

import "./tutorHistory.vue?vue&type=style&index=0&id=450ba8b0&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-450ba8b0"]])

export default __exports__